/**
 * One JSON content type. auth.getAuthHeader already sets Content-type;
 * adding Content-Type as well makes fetch send both, and express.json
 * then ignores the body.
 */
export function envioJsonHeaders(authHeaders) {
  const headers = {...(authHeaders || {})};
  delete headers['Content-type'];
  delete headers['Content-Type'];
  headers['Content-Type'] = 'application/json';
  return headers;
}
